import styled from 'styled-components';

export const ToggleBtn = styled.button`
  cursor: pointer;
  border: none;
  padding: 0;
  background: white;
  border-radius: 50%;
  line-height: 0;
  position: absolute;
  top: 2px;
  right: 2px;
  z-index: 1;

  &.close-modal {
    z-index: 10;
    padding: 5px;
    svg {
      transform: rotate(45deg);
      transition: transform 0.2s;
    }

    &:hover {
      svg {
        transform: rotate(135deg);
      }
    }
  }
`;
